/**
 * @generated SignedSource<<fd3a4cd1c9cd434aac2a9fd645d9b0fc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type itemTopicSearchResultListItemTopic$data = {
  readonly entityId: string;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "itemTopicSearchResultListItemTopic";
};
export type itemTopicSearchResultListItemTopic$key = {
  readonly " $data"?: itemTopicSearchResultListItemTopic$data;
  readonly " $fragmentSpreads": FragmentRefs<"itemTopicSearchResultListItemTopic">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "itemTopicSearchResultListItemTopic",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Topic",
  "abstractKey": null
};

(node as any).hash = "784afe6ac670d3ed52578e26d96c0dda";

export default node;
